<template>
  <section v-if="step === 1" class="category-tool main-ctn">
    <h2>{{ texts.tag }}</h2>
    <div class="card-ctn">
      <div v-for="tag in tags" class="card-single" :key="tag.term_id" @click="select_tag(tag)">
        <img :src="template_directory_uri + '/media/tags/' + tag.tag.slug + '.png'" >
        <h4>{{ tag.tag.name }}</h4>
        <a rel="nofollow" class="arrow-btn"><img :src="template_directory_uri + '/media/arrow-btn.svg'"></a>
      </div>
    </div>
  </section>
  <section v-else-if="step === 2" class="category-tool main-ctn">
    <h2>{{ texts.cat }}</h2>
    <a style="cursor: pointer;transform: rotate(180deg);" rel="nofollow" class="arrow-btn" @click="back()"><img :src="template_directory_uri + '/media/arrow-btn.svg'"></a>
    <div class="card-ctn">
      <div v-for="category in selected_tag.categories" class="card-single" :key="selected_tag.term_id + '-' + category.term_id" @click="select_category(category)">
        <img v-if="category.category.thumbnail" :src="category.category.thumbnail" >
        <h4>{{ category.category.name }}</h4>
        <a rel="nofollow" class="arrow-btn"><img :src="template_directory_uri + '/media/arrow-btn.svg'"></a>
      </div>
    </div>
  </section>
  <section v-else class="category-tool main-ctn">
    <h2>{{ texts.product }}</h2>
    <a style="cursor: pointer;transform: rotate(180deg);" rel="nofollow" class="arrow-btn" @click="back()"><img :src="template_directory_uri + '/media/arrow-btn.svg'"></a>
    <div class="full-card boxed">
      <div class="col-left">
        <span class="breadcrumb">{{ texts.auswahl }}: {{ selected_tag.tag.name }} > {{ selected_category.category.name }}</span>
        <template v-if="selected_category.products.length > 1">
          <details v-for="product in selected_category.products" :key="product.variation_id + '-' + selected_tag.term_id + '-' + selected_category.category.term_id">
            <summary>
              <h4>{{ product.sku }}</h4>
              <a rel="nofollow" :href="'./?add-to-cart=' + product.variation_id + '&quantity=1'" class="add-cart-btn">
                <img :src="template_directory_uri + '/media/cart-white.svg'">
              </a>
            </summary>
            <ul v-html="product.clean_description">
            </ul>
            <a :href="'./?add-to-cart=' + product.variation_id + '&quantity=1'" rel="nofollow" class="back-btn">
              <img :src="template_directory_uri + '/media/cart.svg'"> {{ texts.warenkorb }}
            </a>
          </details>
        </template>
        <template v-else>
          <details open v-for="product in selected_category.products" :key="product.variation_id + '-' + selected_tag.term_id + '-' + selected_category.category.term_id">
            <summary>
              <h4>{{ product.sku }}</h4>
              <a rel="nofollow" :href="'./?add-to-cart=' + product.variation_id + '&quantity=1'" class="add-cart-btn">
                <img :src="template_directory_uri + '/media/cart-white.svg'">
              </a>
            </summary>
            <ul v-html="product.clean_description">
            </ul>
            <a :href="'./?add-to-cart=' + product.variation_id + '&quantity=1'" rel="nofollow" class="back-btn">
              <img :src="template_directory_uri + '/media/cart.svg'"> {{ texts.warenkorb }}
            </a>
          </details>
        </template>
      </div>
      <div class="col-right">
        <img class="product-img" :src="selected_category.products[0].image.url">
        <span class="price">Preis: CHF {{ selected_category.products[0].display_price.toFixed(2) }}</span>
        <p>
          {{ texts.massen }}
          <a rel="nofollow" :href="contact_page_url">{{ texts.kontakt }}</a>
        </p>
      </div>
    </div>

  </section>
</template>

<script>
/* eslint-disable */
export default {
  name: 'App',
  data () {
    return {
      tags: valdev_data.tags,
      template_directory_uri: valdev_data.template_directory_uri,
      contact_page_url: valdev_data.contact_page_url,
      texts: valdev_data.texts,
      selected_tag : null,
      selected_category : null,
      step : 1
    }
  },
  methods: {
    select_tag(tag) {
      this.selected_tag = tag
      this.step++
    },
    select_category(category) {
      this.selected_category = category

      this.step++
    },
    back() {
      this.step--
      if(this.step === 1) {
        this.selected_tag = null
        this.selected_category = null
      }else if(this.step === 2) {
        this.selected_category = null
      }
    }
  }
}
</script>
